import Component from '../app/component'
import barba from '@barba/core'

export default class MobilenavComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    document.addEventListener('mobilenav.toggle', () => this.toggle())
    barba.hooks.afterLeave(() => {
      if (this.el.classList.contains('cm-mobilenav--active')) {
        this.toggle()
      }
    })
  }

  toggle () {
    if (this.el.classList.contains('cm-mobilenav--active')) {
      this.el.classList.remove('cm-mobilenav--active')
      setTimeout(() => document.dispatchEvent(new CustomEvent('top.mobilenav.out')), 350)
    } else {
      this.el.classList.add('cm-mobilenav--active')
      document.dispatchEvent(new CustomEvent('top.mobilenav.in'))
    }
  }
}
